import { Component } from '@angular/core';

@Component({
  selector: 'config-service',
  template: '',
})
export class ConfigServiceComponent {
  constructor() {
    window.location.href = 'assets/config-service.html';
  }
}
